/**
 * Utility functions for handling redirects with base path support
 */

/**
 * Gets the base path for the current environment
 */
function getBasePath(): string {
  const isMainOrDevelop =
    process.env.VERCEL_GIT_COMMIT_REF === "main" ||
    process.env.VERCEL_GIT_COMMIT_REF === "develop" ||
    process.env.NEXT_PUBLIC_VERCEL_ENV === "production" ||
    process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === "develop"

  const isLocalProxy = process.env.LOCAL_PROXY === "true"

  // Check client-side by looking at current URL
  const isClientSideProxy =
    typeof window !== "undefined" &&
    window.location.pathname.startsWith("/minasidor")

  return isMainOrDevelop || isLocalProxy || isClientSideProxy
    ? "/minasidor"
    : ""
}

/**
 * Adds the base path to a URL for redirects
 */
export function withBasePath(path: string): string {
  const basePath = getBasePath()

  if (!basePath || path.startsWith(basePath)) {
    return path
  }

  // Handle absolute URLs (don't add base path)
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  // Ensure path starts with /
  const normalizedPath = path.startsWith("/") ? path : `/${path}`

  return `${basePath}${normalizedPath}`
}

/**
 * Removes the base path from a URL path if it exists
 */
export function withoutBasePath(path: string): string {
  const basePath = getBasePath()

  if (basePath && path.startsWith(basePath)) {
    return path.substring(basePath.length) || "/"
  }

  return path
}

/**
 * Normalizes a path for consistent comparison with page slugs
 * Removes base path and ensures consistent leading slash format
 */
export function normalizePathForSlugComparison(path: string): string {
  const withoutBase = withoutBasePath(path)
  // Remove leading slash to match how slugs are stored (without leading slash)
  return withoutBase.startsWith("/") ? withoutBase.substring(1) : withoutBase
}

/**
 * Default redirect path for after login
 */
export function getDefaultRedirectPath(): string {
  return withBasePath("/oversikt")
}
